// Compartilhado entre features que precisam de comportamento diferente em produção vs.
// local/homolog (ex.: personalização do dashboard, modal de ocorrência da Agenda) — função (não
// uma constante avaliada 1x no import) pra poder ser controlada por `import.meta.env.VITE_MODE`
// em tempo de teste. NÃO usa `NODE_ENV` — o build de produção sempre força
// `NODE_ENV=production` no bundle final, mesmo quando o `.env.staging` do pipeline de homolog
// declara `NODE_ENV=development` (bitbucket-pipelines.yml) — essa declaração nunca chega a valer
// em runtime, só as variáveis `VITE_*` são de fato inlinadas do jeito esperado.
export const isNonProductionEnv = () =>
  import.meta.env.VITE_MODE === 'local' || import.meta.env.VITE_MODE === 'homolog';

export const makeEnvironmentUrl = url => {
  if (!url) return '/dashboard';

  const isLocalEnv = isNonProductionEnv();

  // páginas aspx continuam iguais
  if (/\.aspx$/i.test(url)) return url;

  // se já é rota
  if (url.startsWith('/')) return url;

  try {
    const parsed = new URL(url);

    // em local/homolog usamos apenas o path
    if (isLocalEnv) {
      return parsed.pathname || '/dashboard';
    }

    // produção mantém url completa
    return url;
  } catch {
    return '/dashboard';
  }
};
